import { reset } from 'redux-form';

import { RANDOMIZATION_HYPOTHESIS_TESTING_FORM } from '../names';

export const resetRandomizationHypothesisTestingForm = () =>
  reset(RANDOMIZATION_HYPOTHESIS_TESTING_FORM);
